function urlFilename(url?: string | null): string {
  if (url) {
    const fileName = url.substring(url.lastIndexOf('/') + 1) ?? '';
    return `https://content.3dmanager.app/permalinks/${fileName}`;
  }
  return '';
}

export default urlFilename;
